import { MissedReason } from "../../../domain/use_cases/leedflow/voipCalls/listVoipCalls";

// Cause du manqué (cf backend/src/helpers/livekit/voip-pipeline/voipcall-doc.ts
// et le résolveur unique `resolveMissedReason`, missed-reason.ts)
export const MISSED_REASON_LABELS: Record<MissedReason, string> = {
    caller_hung_up_ringing: 'Raccroché en sonnerie',
    ring_unconfirmed: 'Sonnerie non confirmée',
    caller_hung_up_answering: 'Raccroché pendant la connexion',
    answering_stalled: 'Décroché, connexion jamais établie',
    not_answered_timeout: 'Timeout → messagerie',
    divert_manual: "Refusé par l'utilisateur",
    owner_busy: 'Déjà en ligne',
    owner_unavailable: 'Indisponible (horaires, vacances, ne pas déranger)',
    display_filtered_ios: 'Filtré par iOS (Concentration)',
    push_no_tokens: 'Aucun token push',
    push_failed: "Échec d'envoi du push",
    mint_failed: 'Échec de génération du token',
    caller_left_before_push: "Raccroché avant l'envoi du push",
    voip_disabled: 'VoIP désactivée',
    owner_not_found: 'Propriétaire introuvable',
    undetermined: 'Indéterminé',
    push_not_delivered: 'Push non livré (ancienne valeur)',
};

export const MISSED_REASON_COLORS: Record<MissedReason, string> = {
    caller_hung_up_ringing: 'default',
    ring_unconfirmed: 'blue',
    caller_hung_up_answering: 'orange',
    answering_stalled: 'volcano',
    not_answered_timeout: 'orange',
    divert_manual: 'purple',
    owner_busy: 'magenta',
    owner_unavailable: 'gold',
    display_filtered_ios: 'volcano',
    push_no_tokens: 'red',
    push_failed: 'red',
    mint_failed: 'red',
    caller_left_before_push: 'default',
    voip_disabled: 'gold',
    owner_not_found: 'gold',
    undetermined: 'magenta',
    push_not_delivered: 'red',
};
